import { Locale, Translations, I18nStrategy, I18nInitOptions, I18nConfig, Observer } from './model'
import { SingleLocaleStrategy } from './strategies'

export class I18n {
  private strategy: I18nStrategy
  private supportedLocales: Locale[]
  private defaultLocale: Locale
  private translations: Translations
  private observers: Observer[]

  constructor() {
    this.strategy = new SingleLocaleStrategy('es')
    this.supportedLocales = ['es']
    this.defaultLocale = 'es'
    this.translations = {}
    this.observers = []
  }

  init(options: I18nInitOptions) {
    this.strategy = options.strategy || new SingleLocaleStrategy(options.defaultLocale)
    this.supportedLocales = options.supportedLocales
    this.defaultLocale = options.defaultLocale
    this.translations = options.translations
    this.listenStrategyUpdates()
  }

  subscribe(obs: Observer) {
    this.observers.push(obs)
  }

  unsubscribe(obs: Observer) {
    this.observers = this.observers.filter((observer) => observer !== obs)
  }

  setLocale(locale: Locale) {
    if (locale === this.getLocale()) return

    if (!this.isSupportedLocale(locale)) {
      console.warn(`${locale} is not supported`)
      return
    }

    this.strategy.setLocale(locale)
  }

  getLocale(): Locale {
    const strategyLocale = this.strategy.getLocale()
    return !strategyLocale || !this.isSupportedLocale(strategyLocale)
      ? this.defaultLocale
      : strategyLocale
  }

  getConfig(): I18nConfig {
    const locale = this.getLocale()

    return {
      locale,
      defaultLocale: this.defaultLocale,
      messages: this.translations[locale] || {},
    }
  }

  private listenStrategyUpdates() {
    this.strategy.onUpdate(() => this.notifyUpdate())
  }

  private isSupportedLocale(locale: Locale): boolean {
    return this.supportedLocales.indexOf(locale) !== -1
  }

  private notifyUpdate() {
    const config = this.getConfig()
    this.observers.forEach((obs) => obs(config))
  }
}

const i18n = new I18n()
export default i18n
